import { Action, createReducer, on } from '@ngrx/store';

import * as GreenhouseAction from './greenhouse.actions';
import { GreenhouseModuleState } from '../models/greenhouse.model';

export const initialState: GreenhouseModuleState = {
  greenhouseNoticeVisible: true,
} as GreenhouseModuleState;

const reducer = createReducer(
  initialState,
  on(GreenhouseAction.setGreenhouseNoticeVisibility, (state, { visible }) => ({
    ...state,
    greenhouseNoticeVisible: visible,
  })),
);

export const greenhouseReducer = (state: GreenhouseModuleState | undefined, action: Action) =>
  reducer(state, action);
